import { Table } from "antd";
import React from "react";
import { tableNumericSorter, tableStringSorter } from "../../../utils/table";
import { useTableColumnSearch } from "../../../hooks/table.hook";
import { ExportCSV } from "../../Common/ExportCSV";

const getTableColumns = (getColumnSearchProps = () => ({})) => [
  {
    title: "User Account Creation Date",
    dataIndex: "created_at",
    key: "created_at",
    sorter: tableStringSorter("created_at"),
    ...getColumnSearchProps("created_at"),
  },
  {
    title: "User Last Login Date",
    dataIndex: "last_login",
    key: "last_login",
    sorter: tableStringSorter("last_login"),
    ...getColumnSearchProps("last_login"),
  },
  {
    title: "Logins Count",
    dataIndex: "logins_count",
    key: "logins_count",
    sorter: tableNumericSorter("logins_count"),
    width: "10%",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: tableStringSorter("name"),
    ...getColumnSearchProps("name"),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sorter: tableStringSorter("email"),
    width: "10%",
    ...getColumnSearchProps("email"),
  },
  {
    title: "Connection",
    dataIndex: "connection",
    key: "connection",
    ...getColumnSearchProps("connection"),
  },
];

const UserLoggedDetailsTable = (props) => {
  const { dataSource } = props;
  const { getColumnSearchProps } = useTableColumnSearch();
  const tableColumns = getTableColumns(getColumnSearchProps);
  return (
    <>
      {dataSource.length > 0 && (
        <ExportCSV
          csvData={dataSource}
          fileName="TableResult"
          columnNames={tableColumns}
        />
      )}
      <Table
        className="sm-custom-column-header"
        //   bordered
        pagination={{
          // total: this.state.sortedCount,
          // showTotal: (total) => `Total ${total} items`,
          // position: ["bottomRight"],
          showSizeChanger: true,
          showLessItems: true,
          defaultPageSize: 20,
          size: "large",
        }}
        rowKey="created_at"
        //   onChange={this.onChangePagination}
        dataSource={dataSource}
        columns={tableColumns}
      />
    </>
  );
};

export default UserLoggedDetailsTable;
